import React from 'react';
import { StyleSheet, View, Text, TouchableOpacity, Dimensions } from 'react-native';
import { Colors } from '@/constants/theme';
import { Image } from 'expo-image';
import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StatusBar } from 'expo-status-bar';
import { useRouter } from 'expo-router';
import Constants from 'expo-constants';
import { useIsTablet } from '@/hooks/useIsTablet';

const { width, height } = Dimensions.get('window');

export default function Login() {
    const router = useRouter();
    const isTablet = useIsTablet();
    const version = Constants.expoConfig?.version || '1.0.0';

    return (
        <View style={[styles.container, isTablet && styles.containerTablet]}>
            <StatusBar style="dark" />
            {isTablet ? (
                <View style={styles.mainWrapperTablet}>
                    {/* Top Background Pattern */}
                    <View style={styles.topSection}>
                        <Image
                            source={require('@/assets/images/login-bg.png')}
                            contentFit="cover"
                            style={styles.backgroundImage}
                        />
                    </View>

                    {/* Main Content Card */}
                    <View style={[styles.cardContainer, styles.cardContainerTablet]}>
                        <SafeAreaView style={styles.safeArea} edges={['bottom']}>
                            <View style={styles.content}>
                                {/* Logo and Title */}
                                <View style={styles.logoContainer}>
                                    <View style={styles.logoWrapper}>
                                        <Image
                                            source={require('@/assets/images/White-Logo.png')}
                                            contentFit="contain"
                                            style={styles.logo}
                                        />
                                    </View>
                                    <Text style={styles.title}>Nomadas Chat</Text>
                                </View>

                                {/* Login Button */}
                                <TouchableOpacity 
                                    style={styles.loginButton} 
                                    activeOpacity={0.8}
                                    onPress={() => router.push('/(auth)/scanner')}
                                >
                                    <FontAwesome5 name="qrcode" size={20} color="white" />
                                    <Text style={styles.loginButtonText}>Scan QR to Login</Text>
                                </TouchableOpacity>

                                {/* Login with Token Button */}
                                <TouchableOpacity 
                                    style={styles.tokenButton} 
                                    activeOpacity={0.8}
                                    onPress={() => router.push('/(auth)/token-login')}
                                >
                                    <FontAwesome5 name="key" size={20} color={Colors.brand} />
                                    <Text style={styles.tokenButtonText}>Login with Token</Text>
                                </TouchableOpacity>
                            </View>

                            {/* Footer */}
                            <View style={styles.footer}>
                                <Text style={styles.versionText}>App Ver {version}</Text>
                            </View>
                        </SafeAreaView>
                    </View>
                </View>
            ) : (
                <>
                    {/* Top Background Pattern */}
                    <View style={styles.topSection}>
                        <Image
                            source={require('@/assets/images/login-bg.png')}
                            contentFit="cover"
                            style={styles.backgroundImage}
                        />
                    </View>

                    {/* Main Content Card */}
                    <View style={styles.cardContainer}>
                        <SafeAreaView style={styles.safeArea} edges={['bottom']}>
                            <View style={styles.content}>
                                {/* Logo and Title */}
                                <View style={styles.logoContainer}>
                                    <View style={styles.logoWrapper}>
                                        <Image
                                            source={require('@/assets/images/White-Logo.png')}
                                            contentFit="contain"
                                            style={styles.logo}
                                        />
                                    </View>
                                    <Text style={styles.title}>Nomadas Chat</Text>
                                </View>

                                {/* Login Button */}
                                <TouchableOpacity 
                                    style={styles.loginButton} 
                                    activeOpacity={0.8}
                                    onPress={() => router.push('/(auth)/scanner')}
                                >
                                    <FontAwesome5 name="qrcode" size={20} color="white" />
                                    <Text style={styles.loginButtonText}>Scan QR to Login</Text>
                                </TouchableOpacity>

                                {/* Login with Token Button */}
                                <TouchableOpacity 
                                    style={styles.tokenButton} 
                                    activeOpacity={0.8}
                                    onPress={() => router.push('/(auth)/token-login')}
                                >
                                    <FontAwesome5 name="key" size={20} color={Colors.brand} />
                                    <Text style={styles.tokenButtonText}>Login with Token</Text>
                                </TouchableOpacity>
                            </View>

                            {/* Footer */}
                            <View style={styles.footer}>
                                <Text style={styles.versionText}>App Ver {version}</Text>
                            </View>
                        </SafeAreaView>
                    </View>
                </>
            )}
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#f8fbff', // Light blue background matching the top pattern
    },
    containerTablet: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    mainWrapperTablet: {
        width: '100%',
        maxWidth: 400,
        maxHeight: 800,
        height: '90%',
        borderRadius: 40,
        overflow: 'hidden',
        elevation: 10,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 10,
        },
        shadowOpacity: 0.1,
        shadowRadius: 20,
        backgroundColor: 'white', // Ensure background for shadow
    },
    topSection: {
        height: height * 0.35,
        width: '100%',
        backgroundColor: '#bce1f0', // Light blue color from the pattern
    },
    backgroundImage: {
        ...StyleSheet.absoluteFillObject,
    },
    cardContainer: {
        flex: 1,
        backgroundColor: 'white',
        marginTop: -60, // Overlap the top section
        borderTopLeftRadius: 40,
        borderTopRightRadius: 40,
        paddingHorizontal: 30,
    },
    cardContainerTablet: {
        marginTop: -40, // Reduced overlap for tablet
    },
    safeArea: {
        flex: 1,
    },
    content: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: 50,
    },
    logoContainer: {
        alignItems: 'center',
        marginBottom: 60,
    },
    logoWrapper: {
        width: 120,
        height: 120,
        marginBottom: 10,
    },
    logo: {
        width: '100%',
        height: '100%',
    },
    title: {
        fontSize: 26,
        fontWeight: '500',
        color: '#1a1a1a',
        letterSpacing: 0.5,
    },
    loginButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: Colors.brand, // The specific blue from the design
        width: '100%',
        paddingVertical: 14,
        borderRadius: 8,
        gap: 8,
    },
    loginButtonText: {
        color: 'white',
        fontSize: 18,
        fontWeight: '600',
    },
    tokenButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        width: '100%',
        paddingVertical: 14,
        borderRadius: 8,
        marginTop: 15,
        borderWidth: 1,
        borderColor: Colors.brand,
        gap: 8,
    },
    tokenButtonText: {
        color: Colors.brand,
        fontSize: 18,
        fontWeight: '600',
    },
    footer: {
        alignItems: 'center',
        paddingBottom: 20,
    },
    versionText: {
        color: '#444',
        fontSize: 13,
        fontWeight: '400',
    },
});